class productMedia extends HTMLElement {
  constructor() {
    super();
    const thumbnails = this.querySelectorAll('.media-thumb');
    const slider = this.querySelector('.product-media');
    const container = this.closest('[data-product]');
    console.log(container, 'container');

    slider.addEventListener('sliderMade', () => {
      console.log('SliderMade');
    });
    
      const flkty = Flickity.data(slider);
      thumbnails.forEach((thumb) => {
        thumb.addEventListener('click', function (event) {
          console.log(event, 'EVENT');
          const selectedSlide = thumb.dataset.index;
          flkty.select(selectedSlide - 1);
        });
      });
  

    container.addEventListener('variantchange', (event) => { 
      const variantData = JSON.parse(
        container.querySelector('[data-product-json]').textContent
      );
      const newVariantId = container.querySelector('[name="id"]').value; 
      const selectedVariantArray = Object.values(variantData.variants).filter(
        (obj) => obj.id == newVariantId
      );
      const selectedVariant = selectedVariantArray[0];
      if (selectedVariant.featured_media) {
        const imageIndex = selectedVariant.featured_media.position;
        const flkty = Flickity.data(slider);
        flkty.select(imageIndex - 1);
      }
    });
  }
}
customElements.define('product-media', productMedia);



class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true }); 
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  } 

   
  onButtonClick(event) {
    console.log(event, 'qty change');
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (
        parseInt(this.input.dataset.min) > parseInt(this.input.step) &&
        this.input.value == 0
      ) {
        this.input.value = this.input.dataset.min;
      } else {
        console.log('step up');
        this.input.stepUp();
      }
    } else {
      console.log('step down');
      this.input.stepDown();
    }

    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    if (
      this.input.dataset.min === previousValue &&
      event.target.name === 'minus'
    ) {
      this.input.value = parseInt(this.input.min);
    }
  } 
   
}

customElements.define('quantity-input', QuantityInput);